
import {ChildAccountResponse} from '../../interfaces/childAccountResponse';
import { AdminAccountService, DavisAlertService } from '@DavisDigital/davisdigitalfrontend.module';
class LicenseReassignModalController {
    
    private close:Function; //injected from modal-service
    private closeCallback:Function;
    
    public licenses:any;
    public accountId:string;
    public accountList:any = [];
	public selectedAccount:any;
	public modalStep:number = 1;
	public username:string;
	public loading:boolean = false;
	
	// @ngInject
	constructor(
		public $timeout : ng.ITimeoutService,
		public ModalService	,
		private adminAccountService:AdminAccountService,
		private davisAlertService:DavisAlertService,
	){}
	
	public $onInit = () => {
		this.accountList = [];
		
		this.loading= true;
		this.adminAccountService.getChildrenAccounts(1, 10, 0, {}, true).then( (res:ChildAccountResponse) =>{
			
			//remove existing account
			let removeIndex = res.accounts.map(function(item) { return item.accountID; }).indexOf(this.accountId);
			// remove object
			if( removeIndex > -1 ) {
				res.accounts.splice(removeIndex, 1);
			}
			 
			this.accountList = res.accounts;
			
		}).finally( () =>{
			this.loading= false;
		});
	}
	
    private closeModal = () =>{
		
		this.close?.();
    }
    
    public updatePermission = () => {
    	
    	if( this.loading ) {
    		return;
    	}
    	
    	this.loading = true;
    	//prepare bookid list & accountid for API call
    	let bookIds = [];
    	let accountID = "";
    	for(let license in this.licenses) {
    		bookIds.push(this.licenses[license]['bookID']);
    	}
    	
    	this.adminAccountService.reassignLicensesForAccount(bookIds.join(),this.selectedAccount.accountID, this.accountId).then( (res) =>{
			if( res?.data?.successfulActions.length) {
				this.davisAlertService.success("License has been re assigned.");
				
				this.closeModal();
			}
			if( res?.data?.failureActions.length) {
				this.davisAlertService.error(res.data.data.message);
			}
		}).finally( () =>{
			this.loading= false;
		});
    }
    
    private handleNextStep = () => {
    	if( !this.selectedAccount?.accountID ) {
    		this.davisAlertService.error("please selecte an account to continue.");
    		return;
    	}
    	
    	this.modalStep = 2;
    }
    
    private handleCancelStep = () => {
    	if( this.modalStep == 1) {
    		this.closeModal();
    	}
    	
    	if( this.modalStep == 2) {
    		this.modalStep = 1;
    	}
    }
}

class LicenseReassignModal {
	public restrict: string = 'E';
	public scope:{};
	
	public bindToController = {
	    licenses: "<",
	    username: "<",
	    accountId: "<",
		closeCallback:'<',
		close:'=?',
	};

	public controller = LicenseReassignModalController;
	public controllerAs = 'licenseReassignModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/modals/license-reassign-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export { LicenseReassignModal };
